// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2Y3km","imageUploader":"EGiftCard_imageUploader__DYlCu"};